import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { XMarkIcon } from '../icons/SalesIcons';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero-section');
      if (heroSection && !isDismissed) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsVisible(heroBottom < 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);
  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-442">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-[#FDF8F4]/95 backdrop-blur-md border-t-2 border-[#C4A882] shadow-2xl" data-id="element-443">
          <div className="max-w-7xl mx-auto px-4 py-3 md:py-4 flex items-center justify-between gap-4" data-id="element-444">
            <div className="hidden md:flex items-center gap-4" data-id="element-445">
              <p className="text-[#5C4033] font-medium" data-id="element-446">
                <span className="text-[#9B2335] font-bold" data-id="element-447">
                  Oferta especial:
                </span>{' '}
                21 módulos + 8 bonos
              </p>
              <div className="flex items-baseline gap-2" data-id="element-448">
                <span className="text-sm text-[#5C4033]/40 line-through" data-id="element-449">
                  $69
                </span>
                <span className="font-heading text-xl text-[#9B2335] font-bold" data-id="element-450">
                  $52.49 USD
                </span>
              </div>
            </div>
            <div className="flex-1 md:flex-none flex items-center gap-3" data-id="element-451">
              <CTAButton text="Acceder Ahora" size="md" className="flex-1 md:flex-none text-sm" data-id="element-452" />
              <button onClick={handleDismiss} className="p-2 text-[#5C4033] hover:text-[#9B2335] transition-colors" aria-label="Cerrar barra" data-id="element-453">
                <XMarkIcon size={20} data-id="element-454" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}